import React from "react";
import { MessageSquare, Scale } from "lucide-react";
import SurvivalHUD from "./SurvivalHUD";

const Footer = ({ navigateTo, version, stats }) => {
  return (
    <footer className="w-full bg-zinc-950 border-t border-zinc-900 p-8 mt-auto relative">
      {/* Tethered to the footer container */}
      <SurvivalHUD stats={stats} />

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-xs relative z-20">
        <div className="space-y-4">
          <h4 className="text-white font-black uppercase italic tracking-widest flex items-center gap-2">
            <MessageSquare size={16} className="text-green-500" /> Crew Comms
          </h4>
          <a
            href="https://discord.gg/trap-tycoon"
            target="_blank"
            rel="noreferrer"
            className="text-zinc-500 hover:text-white transition-colors"
          >
            JOIN THE DISCORD
          </a>
        </div>

        <div className="flex flex-col gap-2 md:items-center">
          <h4 className="text-white font-black uppercase italic tracking-widest flex items-center gap-2">
            <Scale size={16} className="text-green-500" /> Legal
          </h4>
          <button
            onClick={() => navigateTo("/terms")}
            className="text-left text-zinc-500 hover:text-white transition-colors uppercase"
          >
            Terms of Service
          </button>
          <button
            onClick={() => navigateTo("/privacy")}
            className="text-zinc-500 hover:text-white transition-colors uppercase"
          >
            Privacy Policy
          </button>
        </div>

        <div className="text-right md:col-start-3">
          <p className="text-[10px] text-zinc-700 font-bold uppercase">
            © {new Date().getFullYear()} TRAP TYCOON | ALL RIGHTS RESERVED
          </p>
          <p className="text-zinc-500 mt-1 font-black italic">
            VERSION:{" "}
            <span className="text-green-900 bg-green-900/10 px-2 border border-green-900/20">
              {version}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
